export const getServiceTypeFrag = `
    id
    name
    type
    expertise {
        code
        name
    }
    allowedFormResidential
    allowedFormAmbulant
    allowedFormField
    settings
    organizationId
`;
